import React, { Component } from 'react';
import { message } from 'antd';
import MachineContactsAddView from '../views/MachineContactsAddView';
import { base } from '../../base';

class MachineContactsAddContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            manager: null,
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleUpdate = this.handleUpdate.bind(this);
        this.managerId = this.props.managerId;
        this.managerRef = null;
    }

    componentDidMount() {
        if (this.managerId) {
            this.managerRef = base.syncState(`contacts/${this.props.extraUser.companyid}/${this.managerId}`, {
                context: this,
                state: 'manager',
            });
        }
    }

    componentWillReceiveProps(props) {
        if (this.props.managerId !== props.managerId) {
            if (this.managerRef != null) {
                base.removeBinding(this.managerRef);
            }
            this.managerRef = base.syncState(`contacts/${props.extraUser.companyid}/${props.managerId}`, {
                context: this,
                state: 'manager',
            });
        }
    }

    componentWillUnmount() {
        if (this.managerRef != null) {
            base.removeBinding(this.managerRef);
        }
    }

    handleSubmit(values) {
        const managerId = this.props.managerId;

        if (managerId) {
            this.handleUpdate(values);
        } else {
            const { closeForm } = this.props;
            base.push(`contacts/${this.props.extraUser.companyid}/`, {
                data: {
                    lastname: values.lastname,
                    name: values.name,
                    email: values.email,
                    phone1: values.phone1,
                    phone2: values.phone2,
                    company: values.company,
                    machines: values.machine,
                    description: values.description,

                },
                then(err) {
                    if (!err) {
                        message.success('Contacto agregado exitosamente');
                        closeForm();
                    }
                },
            });
        }
    }

    handleUpdate(values) {
        const managerId = this.props.managerId;
        const { closeForm } = this.props;
        base.update(`contacts/${this.props.extraUser.companyid}/${managerId}`, {
            data: {
                lastname: values.lastname,
                name: values.name,
                email: values.email,
                phone1: values.phone1,
                phone2: values.phone2,
                company: values.company,
                machines: values.machine,
                description: values.description,
            },
            then(err) {
                if (!err) {
                    message.success('Contacto Editado exitosamente');
                    closeForm();
                }
            },
        });
    }

    render() {
        return (
            <MachineContactsAddView
                manager={this.state.manager}
                openForm={this.props.openForm}
                onCancel={this.props.onCancel}
                closeForm={this.props.closeForm}
                handleSubmit={this.handleSubmit}
                user={this.props.user}
                extraUser={this.props.extraUser}
            />
        );
    }
}

export default MachineContactsAddContainer;



// WEBPACK FOOTER //
// ./src/components/containers/MachineContactsAddContainer.js